import { Grid } from '@mui/material'
import { FormFieldProps } from '../../../models/novelties'
import CustomTextField from '@/contexts/shared/components/inputs/CustomTextField'
import { BrandAutocomplete } from '@/contexts/shared/components/inputs'

const NoveltyHeaderFields = ({ novelty, handleInputChange }: FormFieldProps) => {
  return (
    <Grid container direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
      <Grid item xs={12} md={8}>
        <CustomTextField inputName="title" value={novelty.title} handleInputChange={handleInputChange} required />
      </Grid>
      <Grid item xs={12} md={4}>
        <BrandAutocomplete value={novelty.brand} handleInputChange={handleInputChange} />
      </Grid>
    </Grid>
  )
}

export default NoveltyHeaderFields
